import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';
import { HealthcareProfessionalsApi } from '../../../apis/HealthcareProfessionalsApi/HealthcareProfessionalsApi.ts';
import { HealthcareProfessional } from '../HealthcareProfessional.ts';

export const healthcareProfessionalNewQuery = {
    queryKey: [QueryKeys.healthcareProfessionalNew],
    queryFn: async () => {
        const result = await HealthcareProfessionalsApi.getHealthcareProfessionalNew();
        return result ? new HealthcareProfessional(result) : result;
    },
};

export function useGetHealthcareProfessionalNew() {
    return useLowFrequencyRefreshQuery(healthcareProfessionalNewQuery);
}
